module.exports = __webpack_public_path__ + "static/media/youssef4.a10221a3.webp";